<template>
  <div v-on:contextmenu.prevent="doNothing">
    <b-container fluid>
      <b-row>
        <!-- Main content -->
        <b-col style="padding:0" align="center">
          <br>
          <!-- WyneAtlas logo -->
          <h1 class="main-title">
            <b>
              <span style="color:rgb(109,122,82)">WYNE</span>
            </b>
            <span style="color:black">ATLAS</span>
          </h1>

          <!-- Subtitle -->
          <b-row class="justify-content-center">
            <p class="t-title" style="text-align:center;position:relative;top:-15px;">
              {{ translate("explore by country") }} - {{ translate("discover the regions") }}
            </p>
          </b-row>

          <!-- Country tiles -->
          <b-row
            class="justify-content-center"
            style="margin:0"
          >

            <AtlasCountryTile
              v-for="country in countries"
              :key="country.code"
              :name="translate(country.name)"
              :subtitle="translate(country.subtitle)"
              :image="country.image"
              :flag="country.flag"
              :available="country.available"
              :route="country.route"
            />

          </b-row>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import Cookies from 'js-cookie';

import { translate_word } from '../assets/js/translate.js';

import AtlasCountryTile from '@/components/AtlasCountryTile.vue';

import countries from '@/assets/js/atlas-countries.js';

const flags = {
  en: require('@/assets/img/flags/english.png'),
  fr: require('@/assets/img/flags/francais.png'),
  de: require('@/assets/img/flags/deutsch.png'),
  es: require('@/assets/img/flags/spanish.png'),
  it: require('@/assets/img/flags/italian.png'),
  nl: require('@/assets/img/flags/dutch.png'),
  pt: require('@/assets/img/flags/portuguese.png')
};

export default {
  name: 'AtlasDesktop',

  components: {
    AtlasCountryTile
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language;
    },

    currentLanguageFlag() {
      return flags[this.currentLanguage] || flags.en;
    },

    languages() {
      return [
        { code: 'en', name: 'English', flag: flags.en },
        { code: 'fr', name: 'Français', flag: flags.fr },
        { code: 'de', name: 'Deutsch', flag: flags.de },
        { code: 'es', name: 'Español', flag: flags.es },
        { code: 'it', name: 'Italiano', flag: flags.it },
        { code: 'nl', name: 'Nederlands', flag: flags.nl },
        { code: 'pt', name: 'Português', flag: flags.pt }
      ];
    }
  },


data() {
  return {
    countries: countries
  };
},

  methods: {
    selectLanguage(language) {
      if (!Object.prototype.hasOwnProperty.call(flags, language)) {
        language = 'en';
      }

      this.$store.commit('setLanguage', language);

      Cookies.set('wynelover.language', language, {
        expires: 365,
        path: '/',
        sameSite: 'Lax'
      });
    },

    translate(string) {
      return translate_word(string, this.currentLanguage);
    },

    doNothing() {
    }
  }
};
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
</style>